import axios from './Axios';

const processResponse = (response: any) => response;

const normalizeError = (error: any) => {
  if (error?.response?.status === 401) {
    return 'Session expired. Please log in again.';
  }

  if (error?.response?.data?.errors) {
    return error.response.data.errors;
  }

  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  return error?.message || 'Request failed';
};

const API = {
  async makeRequest(url: string, reqInit: Record<string, unknown>) {
    try {
      const response = await axios({
        url,
        ...reqInit,
      });

      const processed = processResponse(response);
      return {
        status: processed.status,
        ...processed.data,
        headers: processed.headers,
      };
    } catch (error: any) {
      throw new Error(normalizeError(error));
    }
  },

  getParams(queryParams = {}) {
    return queryParams;
  },

  makeGetRequest(path: string, queryParams?: Record<string, unknown>) {
    return this.makeRequest(path, {
      method: 'GET',
      params: this.getParams(queryParams),
      paramsSerializer: {
        indexes: false,
      },
    });
  },

  makePostRequest(path: string, body?: Record<string, unknown>) {
    return this.makeRequest(path, {
      method: 'POST',
      data: body,
    });
  },

  makePostFormDataRequest(
    path: string,
    key?: string,
    data?: Record<string, unknown> | FormData | string | Blob,
    options: Record<string, unknown> = {},
  ) {
    const formData =
      data instanceof FormData ? data : new FormData();

    if (!(data instanceof FormData) && data !== undefined && data !== null) {
      if (
        typeof data === 'string' ||
        data instanceof Blob
      ) {
        if (key) {
          formData.append(key, data);
        }
      } else {
        Object.entries(data).forEach(([field, value]) => {
          if (value === undefined || value === null) return;

          if (Array.isArray(value)) {
            value.forEach((item) => {
              if (item !== undefined && item !== null) {
                formData.append(field, String(item));
              }
            });
            return;
          }

          if (typeof value === 'boolean') {
            formData.append(field, value ? '1' : '0');
            return;
          }

          if (value instanceof Blob) {
            formData.append(field, value);
            return;
          }

          formData.append(field, String(value));
        });
      }
    }

    return this.makeRequest(path, {
      method: 'POST',
      data: formData,
      headers: {
        Accept: 'application/json',
      },
      ...options,
    });
  },

  makePutRequest(path: string, body?: Record<string, unknown>) {
    return this.makeRequest(path, {
      method: 'PUT',
      data: body,
      params: this.getParams(),
      paramsSerializer: {
        indexes: false,
      },
    });
  },
};

export default API;
